import moment from "moment";
import Select from "react-select";
import { CSVLink } from "react-csv";
import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledCollapse,
} from "reactstrap";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { capitalizeFirstLetter, getAuthUser } from "../GeneralFunctions";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { GlobalContext } from "../components/Layout/MainLayout";
let user = {};

class TransactionHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: 0,
      limit: 10,
      fromDate: new Date().setUTCDate(1),
      toDate: new Date(),
      status: "all",
      type: "all",
      pageNumbers: [],
      transactions: [],
      showLoader: false,
      filterCollapse: true,
      totalTransactions: 0,
      showReprocessButton: false,
      reprocessTransactionConfirmationModal: false,
      Camps: [],
      selectedCamp: [],
      parentEvents: [],
      selectedParentEvent: {},
      CSVHeaders: [],
      CSVData: [],
      transactionCSVHeaders: [],
      transactionCSVData: [],
    };
  }

  componentDidMount() {
    user = getAuthUser();
    user.connectedUser && user.connectedUser.SPIEvent
      ? this.getSPIEvents()
      : this.getCamps();
  }

  getCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `camp/web/list?parentEventId=${this.state.selectedParentEvent.value}`,
        method: "GET",
      });
      if (response) {
        if (response.camps && response.camps.length) {
          this.setState(
            {
              showLoader: false,
              Camps: response.camps,
              selectedCamp: [
                {
                  value: "all",
                  label: "All",
                },
              ],
              limit: this.context.limit,
            },
            () => this.getTransactions()
          );
        } else {
          this.setState(
            {
              showLoader: false,
              Camps: [],
              limit: this.context.limit,
            },
            () => this.getTransactions()
          );
        }
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getSPIEvents = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/rushNational/camps",
        method: "GET",
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            parentEvents: response.camps,
            selectedParentEvent: {
              value: response.camps[0]._id,
              label: response.camps[0].name,
            },
          },
          () => this.getCamps()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getTransactions = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let allcamps = this.state.selectedCamp.find(
        (camp) => camp.value === "all"
      );
      let campIds = allcamps
        ? this.state.Camps.map((camp) => camp._id)
        : this.state.selectedCamp.map((camp) => camp.value);
      let response = await Server.request({
        url: "rushsoccer/transaction/history",
        method: "POST",
        data: {
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          type: this.state.type,
          status: this.state.status,
          page,
          pageLimit,
          campIds,
        },
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            totalTransactions: response.totalTransactions,
            pages: response.pages,
            showReprocessButton: this.state.status === "failed" ? true : false,
            CSVHeaders: [],
            CSVData: [],
          },
          () => this.csvData(response.transactions)
        );
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({
          pageNumbers: pageNumbers,
          transactions: response.transactions,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadTransactionAllRecords = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let allcamps = this.state.selectedCamp.find(
        (camp) => camp.value === "all"
      );
      let campIds = allcamps
        ? this.state.Camps.map((camp) => camp._id)
        : this.state.selectedCamp.map((camp) => camp.value);
      let response = await Server.request({
        url: "rushsoccer/download/transaction/allRecords",
        method: "POST",
        data: {
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          type: this.state.type,
          status: this.state.status,
          campIds,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          transactionCSVHeaders: response.transactionCSVHeaders,
          transactionCSVData: response.transactionCSVData,
        });
      }
      this.csvLink.link.click();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  reprocessTransactions = async () => {
    try {
      this.setState({ showLoader: true });
      let reprocessTransactions = this.state.transactions.map((transaction) => {
        switch (transaction.interval) {
          case "monthly subscription":
            return {
              transactionId: transaction._id,
              id: transaction.subscriptions._id,
            };
          case "month":
            return {
              transactionId: transaction._id,
              id: transaction.installmentsPaid._id,
            };
        }
      });
      let response = await Server.request({
        url: "rushsoccer/reprocess/transaction",
        method: "POST",
        data: {
          fromWeb: true,
          transactions: reprocessTransactions,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTransactions();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  csvData = (transactions) => {
    this.setState({
      CSVHeaders: [
        { label: "Customer Id", key: "customerId" },
        { label: "Amount", key: "amount" },
        { label: "Status", key: "status" },
        { label: "Birth Date", key: "birthDate" },
        { label: "Player", key: "childName" },
        { label: "Adult", key: "parentName" },
        { label: "Phone", key: "parentPhone" },
        { label: "Email", key: "parentEmail" },
        { label: "Team", key: "teamName" },
        { label: "Event", key: "event" },
        { label: "Paid Date", key: "paidDate" },
        { label: "Due Date", key: "dueDate" },
      ],
    });
    transactions.length > 0 &&
      transactions.map((transaction) => {
        let amount = transaction.displayPrice.toFixed(2);
        let status = transaction.displayStatus
          ? capitalizeFirstLetter(transaction.displayStatus)
          : "-";
        let birthDate = transaction.rushUser.child.data.birthday
          ? moment.utc(transaction.rushUser.child.data.birthday).format("L")
          : "-";
        let childName =
          typeof transaction.rushUser === "object"
            ? `${capitalizeFirstLetter(
                transaction.rushUser.child.data.firstName || ""
              )} ${capitalizeFirstLetter(
                transaction.rushUser.child.data.lastName || ""
              )}`
            : "-";
        let parentName =
          typeof transaction.rushUser === "object"
            ? `${capitalizeFirstLetter(
                transaction.rushUser.data.firstName || ""
              )} ${capitalizeFirstLetter(
                transaction.rushUser.data.lastName || ""
              )}`
            : "-";
        let parentPhone =
          typeof transaction.rushUser === "object"
            ? transaction.rushUser.data.username
            : "-";
        let parentEmail =
          typeof transaction.rushUser === "object"
            ? transaction.rushUser.data.email
            : "-";
        let event = transaction.campName
          ? capitalizeFirstLetter(transaction.campName)
          : "-";
        let teamName = Array.isArray(transaction.teamNames)
          ? transaction.teamNames.join(",")
          : "-";
        let paidDate = transaction.paidDate
          ? moment.utc(transaction.paidDate).format("L")
          : "-";
        let dueDate = transaction.dueDate
          ? moment.utc(transaction.dueDate).format("L")
          : "-";
        this.state.CSVData.push({
          customerId: transaction.rushUser.stripeId,
          amount,
          status,
          birthDate,
          childName,
          parentName,
          parentPhone,
          parentEmail,
          teamName,
          event,
          paidDate,
          dueDate,
        });
        return transaction;
      });
    this.forceUpdate();
  };

  renderPlayerDetailPage = async (childId) => {
    if (childId) {
      this.props.history.push({
        pathname: "/playerDetail",
        state: { childId },
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getTransactions();
    });
  };

  renderPlayerPaymentDetailPage = async (transaction) => {
    let status =
      new Date(transaction.endingAt).getTime() > new Date().getTime()
        ? "inactive"
        : "active";
    this.props.history.push({
      pathname: "/playerPaymentDetail",
      state: {
        camp: {
          status,
          campName: transaction.campName,
          transactionId: transaction._id,
        },
        username: transaction.rushUser.data.username,
        playerName: `${transaction.rushUser.child.data.firstName} ${transaction.rushUser.child.data.lastName}`,
      },
    });
  };

  toggleReprocessTransactionConfirmationModal = () => {
    this.setState({
      reprocessTransactionConfirmationModal: !this.state
        .reprocessTransactionConfirmationModal,
    });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Transaction-History"
          breadcrumbs={[{ name: "Transaction-History", active: true }]}
        >
          <Card>
            <CardHeader>
              <Row>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex">
                    <div sm={4} className="mt-2 pr-2">
                      <Label>Shown</Label>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        name="pageLimit"
                        value={this.state.limit}
                        onChange={(event) => {
                          this.refreshPagination(1, event.target.value);
                          this.context.updateState({
                            limit: event.target.value,
                          });
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Input>
                    </div>
                    <div sm={4} className="mt-2 pl-2">
                      <Label>entries</Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-center">
                    <div className="mt-2 pr-2">
                      <Label>
                        Showing{" "}
                        {!this.state.totalTransactions
                          ? 0
                          : this.state.page * this.state.limit -
                            (this.state.limit - 1) +
                            " "}{" "}
                        to{" "}
                        {this.state.page * this.state.limit >
                        this.state.totalTransactions
                          ? this.state.totalTransactions
                          : this.state.page * this.state.limit}{" "}
                        of {this.state.totalTransactions}
                      </Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-end">
                    <div sm={4} className="pr-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page <= 1}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page - 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                      </Button>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        value={this.state.page}
                        name="filter"
                        onChange={(event) => {
                          this.refreshPagination(
                            event.target.value,
                            this.state.limit
                          );
                        }}
                      >
                        {this.state.pageNumbers.length !== 0 ? (
                          this.state.pageNumbers.map((pageNumber, index) => (
                            <option value={pageNumber} key={index}>
                              {pageNumber}
                            </option>
                          ))
                        ) : (
                          <option value={0}>0</option>
                        )}
                      </Input>
                    </div>
                    <div sm={4} className="pl-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page >= this.state.pages}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page + 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xl={12} lg={12} md={12}>
                  <div>
                    <Button
                      color="primary"
                      id="toggler1"
                      style={{ width: "50%", marginBottom: "1rem" }}
                      onClick={() => {
                        this.setState({
                          filterCollapse: !this.state.filterCollapse,
                        });
                      }}
                    >
                      Filters
                    </Button>
                  </div>
                  <UncontrolledCollapse
                    toggler="#toggler1"
                    isOpen={this.state.filterCollapse}
                  >
                    <Card>
                      <CardBody>
                        <Form
                          className="form"
                          onSubmit={(event) => this.getTransactions(event)}
                        >
                          <Row>
                            <Col md={6}>
                              <Label>From Date:</Label>
                              <Input
                                type="date"
                                name="fromDate"
                                required
                                placeholder="fromDate"
                                defaultValue={
                                  moment(new Date(this.state.fromDate)).format(
                                    "YYYY-MM-DD"
                                  ) || ""
                                }
                                onChange={(event) => {
                                  event.persist();
                                  this.setState({
                                    fromDate: event.target.value,
                                  });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={6}>
                              <Label>To Date:</Label>
                              <Input
                                type="date"
                                name="toDate"
                                required
                                placeholder="toDate"
                                defaultValue={
                                  moment(new Date(this.state.toDate)).format(
                                    "YYYY-MM-DD"
                                  ) || ""
                                }
                                onChange={(event) => {
                                  event.persist();
                                  this.setState({ toDate: event.target.value });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={3}>
                              <Label> Status:</Label>
                              <div>
                                <select
                                  className="btn selectCss"
                                  value={this.state.status}
                                  onChange={(event) =>
                                    this.setState({
                                      status: event.target.value,
                                    })
                                  }
                                  style={{ width: "100%" }}
                                >
                                  <option value="all">All</option>
                                  <option value="pending">Pending</option>
                                  <option value="paid">Paid</option>
                                  <option value="failed">Failed </option>
                                  <option value="cancelled">Cancelled</option>
                                  <option value="refund">Refund</option>
                                </select>
                              </div>
                            </Col>
                            <Col md={3}>
                              <Label> Type:</Label>
                              <div>
                                <select
                                  className="btn selectCss"
                                  value={this.state.type}
                                  onChange={(event) =>
                                    this.setState({
                                      type: event.target.value,
                                    })
                                  }
                                  style={{ width: "100%" }}
                                >
                                  <option value="all">All</option>
                                  <option value="fullPayment">
                                    Full Payment
                                  </option>
                                  <option value="installments">
                                    Installments
                                  </option>
                                  <option value="subscriptions">
                                    Subscriptions
                                  </option>
                                </select>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={6}>
                              {user.connectedUser &&
                                user.connectedUser.SPIEvent && (
                                  <>
                                    <Label for="name">Select Event :</Label>
                                    <Select
                                      value={this.state.selectedParentEvent}
                                      options={[
                                        ...this.state.parentEvents.map(
                                          (parentEvent) => ({
                                            value: parentEvent._id,
                                            label: parentEvent.name,
                                          })
                                        ),
                                      ]}
                                      onChange={(result) =>
                                        this.setState(
                                          {
                                            selectedParentEvent: result,
                                          },
                                          () => this.getCamps()
                                        )
                                      }
                                    />
                                  </>
                                )}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={6}>
                              <Label for="name1">Event :</Label>
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                value={this.state.selectedCamp}
                                options={[
                                  {
                                    value: "all",
                                    label: "All",
                                  },
                                  ...this.state.Camps.map((camp) => ({
                                    value: camp._id,
                                    label: camp.name,
                                  })),
                                ]}
                                onChange={(result) =>
                                  this.setState({
                                    selectedCamp: result,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3"></Row>
                          <Row className="mt-3">
                            <Col xl={12} lg={12} md={12}>
                              <Button
                                className="mr-3 mb-3"
                                color="primary"
                                type="submit"
                              >
                                Filter
                              </Button>
                              <Button
                                className="mr-3 mb-3"
                                onClick={() =>
                                  this.setState({
                                    monthDate: new Date(),
                                    status: "paid",
                                    type: "installments",
                                  })
                                }
                              >
                                Reset Filter
                              </Button>
                              <Button className="mr-3 mb-3" onClick={() => {}}>
                                <CSVLink
                                  className="text-white"
                                  style={{ textDecoration: "unset" }}
                                  filename={`transactions.csv`}
                                  data={this.state.CSVData}
                                  headers={this.state.CSVHeaders}
                                >
                                  Download csv
                                </CSVLink>
                              </Button>
                              <Button
                                className="mr-3 mb-3"
                                onClick={(event) =>
                                  this.downloadTransactionAllRecords(event)
                                }
                              >
                                Download all transactions
                              </Button>
                              <CSVLink
                                className="text-white"
                                style={{ textDecoration: "unset" }}
                                filename={`transactions.csv`}
                                data={this.state.transactionCSVData}
                                headers={this.state.transactionCSVHeaders}
                                ref={(ref) => {
                                  this.csvLink = ref;
                                }}
                              ></CSVLink>
                              {this.state.showReprocessButton && (
                                <Button
                                  className="mr-3 mb-3"
                                  onClick={() =>
                                    this.toggleReprocessTransactionConfirmationModal()
                                  }
                                >
                                  Reprocess Failed Transaction
                                </Button>
                              )}
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </Col>
              </Row>
              <Row>
                <Col xl={12} lg={12} md={12}>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Name</th>
                        <th>Event</th>
                        <th>Due Date</th>
                        <th>Paid Date</th>
                        <th>View Detail</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.transactions.length > 0 ? (
                        this.state.transactions.map((transaction, index) => (
                          <tr
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.renderPlayerDetailPage(
                                transaction.rushUser &&
                                  transaction.rushUser.child._id
                              )
                            }
                          >
                            <td>
                              {`****${transaction._id.slice(
                                transaction._id.length - 5,
                                transaction._id.length
                              )}`}
                            </td>
                            <td>{transaction.displayPrice.toFixed(2)}</td>
                            <td>
                              {transaction.displayStatus
                                ? capitalizeFirstLetter(
                                    transaction.displayStatus
                                  )
                                : "-"}
                            </td>
                            <td>
                              {typeof transaction.rushUser === "object"
                                ? capitalizeFirstLetter(
                                    transaction.rushUser.child.data.firstName ||
                                      " "
                                  ) +
                                  " " +
                                  capitalizeFirstLetter(
                                    transaction.rushUser.child.data.lastName
                                  )
                                : "-"}
                            </td>
                            <td>
                              {transaction.campName
                                ? capitalizeFirstLetter(transaction.campName)
                                : "-"}
                            </td>
                            <td>
                              {transaction.dueDate
                                ? moment.utc(transaction.dueDate).format("LL")
                                : "-"}
                            </td>
                            <td>
                              {transaction.paidDate
                                ? moment.utc(transaction.paidDate).format("LL")
                                : "-"}
                            </td>
                            <td
                              style={{
                                cursor: "pointer",
                                color: "blue",
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                                this.renderPlayerPaymentDetailPage(transaction);
                              }}
                            >
                              View
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No transactions found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
            {this.state.reprocessTransactionConfirmationModal ? (
              <Modal
                isOpen={this.state.reprocessTransactionConfirmationModal}
                toggle={(event) =>
                  this.toggleReprocessTransactionConfirmationModal()
                }
                className="modal-md"
              >
                <ModalHeader
                  toggle={(event) =>
                    this.toggleReprocessTransactionConfirmationModal()
                  }
                >
                  Reprocess Transaction
                </ModalHeader>
                <ModalBody>
                  Are you sure you want to reprocess failed transaction ?
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={(event) =>
                      this.toggleReprocessTransactionConfirmationModal()
                    }
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    onClick={(event) => {
                      this.toggleReprocessTransactionConfirmationModal();
                      this.reprocessTransactions();
                    }}
                  >
                    Process
                  </Button>
                </ModalFooter>
              </Modal>
            ) : null}
          </Card>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
TransactionHistory.contextType = GlobalContext;
export default TransactionHistory;
